var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17069_1052483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60471 14.2707C5.27359 14.5925 5.27358 15.1241 5.60471 15.4459C5.92239 15.7545 6.42788 15.7548 6.7459 15.4465L9.65196 12.6289C9.84589 12.4409 10.1541 12.4409 10.348 12.6289L13.2541 15.4465C13.5721 15.7548 14.0776 15.7545 14.3953 15.4459C14.7264 15.1241 14.7264 14.5925 14.3953 14.2707L10.3484 10.3386C10.1544 10.15 9.8456 10.15 9.65156 10.3386L5.60471 14.2707Z",
    fill: "#79808A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3972 4.72743C14.7273 4.4067 14.7273 3.8767 14.3972 3.55597C14.079 3.24683 13.5723 3.24818 13.2558 3.55901L10.3782 6.38509C10.1823 6.57752 9.86779 6.5759 9.67385 6.38147L6.86821 3.56884C6.54914 3.24898 6.03648 3.23198 5.69692 3.53001C5.32131 3.85969 5.30661 4.43962 5.66505 4.7879L9.65156 8.66144C9.8456 8.84997 10.1544 8.84997 10.3484 8.66144L14.3972 4.72743Z",
    fill: "#79808A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17069_1052483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.1fd4d56d197eec6443041b21e8ca2897.svg";
export { ForwardRef as ReactComponent };